var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container-fluid zoom", attrs: { id: "overview" } },
    [
      _c("div", { staticClass: "card" }, [
        _c(
          "div",
          { staticClass: "card-body" },
          [
            _c(
              "b-row",
              { staticClass: "my-1" },
              [
                _c("b-col", { attrs: { sm: "1" } }, [
                  _c("label", { attrs: { for: "filterInput" } }, [
                    _vm._v("Filter:"),
                  ]),
                ]),
                _c(
                  "b-col",
                  { attrs: { sm: "9" } },
                  [
                    _c(
                      "b-input-group",
                      { attrs: { size: "sm" } },
                      [
                        _c("b-form-input", {
                          attrs: {
                            type: "search",
                            id: "filterInput",
                            placeholder: "Type to Search",
                            size: "sm",
                          },
                          model: {
                            value: _vm.filter,
                            callback: function ($$v) {
                              _vm.filter = $$v
                            },
                            expression: "filter",
                          },
                        }),
                        _c(
                          "b-input-group-append",
                          [
                            _c(
                              "b-button",
                              {
                                staticStyle: { margin: "0" },
                                attrs: { disabled: !_vm.filter },
                                on: {
                                  click: function ($event) {
                                    _vm.filter = ""
                                  },
                                },
                              },
                              [_vm._v("Clear")]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "b-col",
                  { attrs: { sm: "2" } },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "pull-right",
                        staticStyle: { margin: "0" },
                        attrs: { size: "sm", variant: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.$router.push({ name: "New Booking" })
                          },
                        },
                      },
                      [_vm._v("Create New booking")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  { staticClass: "my-1", attrs: { lg: "12" } },
                  [
                    _c("b-table", {
                      attrs: {
                        headVariant: "dark",
                        "table-variant": "primary",
                        responsive: "",
                        outlined: "",
                        bordered: "",
                        small: "",
                        hover: "",
                        "show-empty": "",
                        "primary-key": "ID",
                        items: _vm.rows,
                        fields: _vm.columns,
                        busy: _vm.isBusy,
                        filter: _vm.filter,
                        "per-page": _vm.perPage,
                        "current-page": _vm.currentPage,
                      },
                      on: { "row-clicked": _vm.rowDblClk },
                      scopedSlots: _vm._u([
                        {
                          key: "table-busy",
                          fn: function () {
                            return [
                              _c(
                                "div",
                                { staticClass: "text-center text-danger my-2" },
                                [
                                  _c("b-spinner", {
                                    staticClass: "align-middle",
                                  }),
                                  _c("strong", [_vm._v("Loading...")]),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "empty",
                          fn: function (scope) {
                            return [_c("h4", [_vm._v(_vm._s(scope.emptyText))])]
                          },
                        },
                        {
                          key: "emptyfiltered",
                          fn: function (scope) {
                            return [
                              _c("h4", [
                                _vm._v(_vm._s(scope.emptyFilteredText)),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("b-pagination", {
                      staticClass: "my-0",
                      attrs: {
                        "total-rows": _vm.itemCount,
                        "per-page": _vm.perPage,
                        align: "center",
                        size: "sm",
                      },
                      model: {
                        value: _vm.currentPage,
                        callback: function ($$v) {
                          _vm.currentPage = $$v
                        },
                        expression: "currentPage",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "fill" }, [
        _c("img", { attrs: { src: _vm.bgPath, alt: "bgPath" } }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }